/* Sports Mom Co. — theme.js */

// Newsletter form basic submit
document.addEventListener('DOMContentLoaded', function () {
  // Sticky header shadow on scroll
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 8) {
        header.style.boxShadow = '0 2px 12px rgba(10, 21, 48, 0.06)';
      } else {
        header.style.boxShadow = 'none';
      }
    });
  }

  // Pause marquee on hover (already CSS but enforce reduced motion fallback)
  const marquee = document.querySelector('.marquee');
  if (marquee && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    marquee.style.animation = 'none';
  }

  // Quantity selectors on product page
  document.querySelectorAll('[data-qty-btn]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const input = btn.parentElement.querySelector('input[type="number"]');
      if (!input) return;
      const dir = btn.dataset.qtyBtn;
      let val = parseInt(input.value || '1', 10);
      val = dir === 'plus' ? val + 1 : Math.max(1, val - 1);
      input.value = val;
    });
  });
});
